export const SET_IDV_STATUS = 'SET_IDV_STATUS';
export const SET_IDV_RETURN_PARAM = 'SET_IDV_RETURN_PARAM';

export const setIdvStatus = (value) => ({
  type: SET_IDV_STATUS,
  value,
});

export const setIdvReturnParam = (value) => ({
  type: SET_IDV_RETURN_PARAM,
  value,
});
